export default [
	{
		name: "user-basic",
		path: "/basic",
		component: () => import("@/views/user/Basic"),
		meta: { layout: "User", menu: "", title: "Dot Apps : Profile" }
    },
	{
		name: "user-edit",
		path: "/edit",
		component: () => import("@/views/user/Edit"),
		meta: { layout: "User", menu: "", title: "Dot Apps : Profile" }
	},
	{
		name: "user-delete",
		path: "/delete",
		component: () => import("@/views/user/Delete"),
		meta: { layout: "User", menu: "", title: "Dot Apps : Profile" }
	},
	{
		name: "user-reset-password",
		path: "/resetPwd",
		component: () => import("@/views/user/ResetPwd"),
		meta: { layout: "User", menu: "", title: "Dot Apps : Profile" }
	},
	{
		name: "user-edit-account",
		path: "/editAccount",
		component: () => import("@/views/user/EditAccount"),
		meta: { layout: "User", menu: "", title: "Dot Apps : Profile" }
	},
];
